import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Scissors, Copy, CheckCircle2, Ticket } from 'lucide-react';
import api from '../../config/api';
import './Coupons.css';

const Coupons = () => {
    const navigate = useNavigate();
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [copiedId, setCopiedId] = useState(null);

    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const response = await api.get('/cms/promocodes');
                setCoupons(response.data);
            } catch (error) {
                console.error("Error fetching coupons:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCoupons();
    }, []);

    const handleCopy = (code, id) => {
        navigator.clipboard.writeText(code);
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 2000);
    };

    const getCouponColor = (type) => {
        if (type === 'percent') return '#C5192D';
        if (type === 'fixed') return '#3b82f6';
        return '#48c479';
    };

    return (
        <div className="coupons-page">
            <header className="coupons-header">
                <button onClick={() => navigate(-1)} className="back-btn">
                    <ArrowLeft size={24} />
                </button>
                <h1>My Coupons</h1>
                <div style={{ width: 40 }}></div>
            </header>

            <div className="coupons-container">
                <div className="coupons-intro">
                    <h2>Available Offers & Coupons</h2>
                    <p>Save more on your favorite meals with these exclusive deals.</p>
                </div>

                {loading ? (
                    <div className="space-y-4 animate-pulse">
                        {[1, 2, 3].map(i => (
                            <div key={i} style={{ height: 110, background: '#f8fafc', borderRadius: 16, border: '1px solid #e2e8f0' }}></div>
                        ))}
                    </div>
                ) : coupons.length > 0 ? (
                    <div className="coupons-list">
                        {coupons.map((coupon) => (
                            <div key={coupon._id} className="coupon-card">
                                <div className="coupon-left" style={{ backgroundColor: getCouponColor(coupon.offerType) }}>
                                    <div className="discount-badge">
                                        {coupon.offerType === 'percent' ? `${coupon.discountValue}% OFF` : `${coupon.discountValue} OFF`}
                                    </div>
                                    <div className="scissors-line">
                                        <Scissors size={14} className="scissors-icon" />
                                    </div>
                                </div>
                                
                                <div className="coupon-right">
                                    <div className="coupon-info">
                                        <h3 className="coupon-code-display">{coupon.code}</h3>
                                        <p className="coupon-upto">
                                            {coupon.maxDiscountAmount ? `Up to ${coupon.maxDiscountAmount}` : 'No Max Limit'}
                                        </p>
                                        <p className="coupon-desc">{coupon.description || `Valid on orders above ${coupon.minOrderValue}`}</p>
                                        <div className="coupon-footer">
                                            <span className="expiry-tag">
                                                Expires {new Date(coupon.expiryDate).toLocaleDateString()}
                                            </span>
                                            <button 
                                                className={`copy-btn ${copiedId === coupon._id ? 'copied' : ''}`}
                                                onClick={() => handleCopy(coupon.code, coupon._id)}
                                            >
                                                {copiedId === coupon._id ? <CheckCircle2 size={16} /> : <Copy size={16} />}
                                                {copiedId === coupon._id ? 'Copied' : 'Copy Code'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="coupons-empty">
                        <Ticket size={64} color="#ccc" />
                        <h3>No Coupons Available</h3>
                        <p>Check back later for new offers and discounts.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Coupons;
